import { useCallback, useMemo } from 'react';

import SimpleTableCell from '@/components/SimpleTable/SimpleTableCell';
import SimpleTableRow from '@/components/SimpleTable/SimpleTableRow';
import { SortDirectionEnum } from '@/models/gen/graphql';
import { useSummaryHistory } from '@/features/SummaryHistory';

const SummaryHistoryTableColumns = (): JSX.Element => {
  return (
    <SimpleTableRow header>
      <SelectAllCell />
      <SortableCell name="CREATED_AT">Created</SortableCell>
      <SortableCell name="DISPATCHER">Name</SortableCell>
      <SortableCell name="SHIFT">Shift</SortableCell>
      <SortableCell name="CALL_VOLUME">Call Volume</SortableCell>
    </SimpleTableRow>
  );
};

const SelectAllCell = (): JSX.Element => {
  const [{ summaries, selected }, setState] = useSummaryHistory(({ summaries, selected }) => ({ summaries, selected }));

  const isSelectAll = useMemo((): boolean => {
    if (selected.size !== summaries.size) return false;
    for (const id of selected.keys()) {
      if (!summaries.has(id)) return false;
    }
    return true;
  }, [summaries, selected]);

  const onClick = useCallback(
    (): void => setState((current) => ({ ...current, selected: isSelectAll ? new Map() : summaries })),
    [summaries, isSelectAll, setState]
  );

  return <SimpleTableCell.Select checked={isSelectAll} onChange={onClick} />;
};
const SortableCell = ({ name, children }: { name: string; children: React.ReactNode }): JSX.Element => {
  const [{ sortBy, sortDirection }, setState] = useSummaryHistory(({ sortBy, sortDirection }) => ({ sortBy, sortDirection }));
  const onSort = (name: string, direction: SortDirectionEnum): void =>
    setState((current) => ({ ...current, sortBy: name, sortDirection: direction }));
  return (
    <SimpleTableCell.Sortable name={name} sortBy={sortBy} sortDirection={sortDirection} onSort={onSort}>
      {children}
    </SimpleTableCell.Sortable>
  );
};

export default SummaryHistoryTableColumns;
